import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { ImUsers, ImUserPlus } from "react-icons/im";
import AccountsCreateForm from "pages/accounts/AccountsCreateForm";
import ProfileView from "pages/accounts/ProfileView";
import { useDispatch } from "react-redux";
import { createFillingPersonThunk } from "store/reducers/accounts";
function FillingPersonAccount() {
  const dispatch = useDispatch();
  const formCallback = (input) => {
    console.log(input);
    dispatch(createFillingPersonThunk(input));
  };
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Delivery boys"
        viewIcon={<ImUsers />}
        createIcon={<ImUserPlus />}
        createChildren={
          <AccountsCreateForm mod="Delivery boy" callback={formCallback} />
        }
        listChildren={<ProfileView mod="fillingPerson" />}
      />
    </Box>
  );
}

export default FillingPersonAccount;
